/**
 * Payload para autorizar (sin `uuid`) o recibir (con `uuid`) una devolución.
 * @param {Object} form Estado del drawer.
 * @returns {Object} Cuerpo del POST.
 */
export const buildReturnPayload = (form) => {
  if (form.uuid) {
    return {
      items: form.items.map((row) => ({
        uuid_return_item: row.uuid,
        quantity: Number(row.quantity || 0),
      })),
    };
  }
  return {
    request_id: form.request_id,
    uuid_project: form.uuid_project,
    uuid_warehouse: form.uuid_warehouse,
    responsible: form.responsible,
    reason: form.reason,
    items: form.items.map((row) => ({
      uuid_consumption_item: row.uuid_consumption_item,
      uuid_inventory_article: row.uuid_inventory_article,
      quantity: Number(row.quantity),
      legacy_evidence: row.uuid_consumption_item ? null : form.legacy_evidence,
    })),
  };
};
